import { render, staticRenderFns } from "./PrintJournalSettlementExternal.vue?vue&type=template&id=070868ae"
import script from "./PrintJournalSettlementExternal.vue?vue&type=script&lang=js"
export * from "./PrintJournalSettlementExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports